import { useState,useEffect } from 'react';
import { Card, CardContent, Grid, ListItem, List, makeStyles, Typography, ListItemText, Button } from '@material-ui/core';
import {Theme,withStyles,Dialog,createStyles } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import { useSelector, useDispatch } from 'react-redux';
import UtilService from "../../../../../helper/service";
import { getStripeProductsList} from "../../../../../store/actions/admin/user";
import PurchaseSubscriptionModal from "../../../../atoms/modals/PurchaseSubscriptionModal"
import UpgradeSubscriptionModal from "../../../../atoms/modals/UpgradeSubscriptionModal"
import AddUserLicences from "../../../../atoms/modals/AddUserLicences"
import SuccessModal from '../../../../atoms/modals/successModal';
import {BackDropAnalyzeLoading } from '../../../../atoms/commonLoadings';
import Config from "../../../../../config/config";
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import { Link } from "react-router-dom";
import axios from 'axios'
const auth_token = localStorage.getItem("auth_token")
const idToken = localStorage.getItem("idToken")
import AddCardDetailModal from "../../../../atoms/modals/AddCardDetailModal"
import {notificationFail} from "../../../../../store/actions/admin/user";
const styles = (theme: Theme) =>
  createStyles({
      root: {
          // margin: 0,
          // padding: theme.spacing(2),
          // paddingTop: 26
      },
      closeButton: {
          position: 'absolute',
          right: theme.spacing(1),
          background: 'transparent !important',
      },
      header: {
          color: '#212D40',
          fontFamily: 'Spartan-bold',
          fontSize: 18,
          padding: 10,
          display: 'flex',
          alignItems: 'center'
      }
  });

const useStyles = makeStyles({
  root: {
    marginBottom: 20,
    borderRadius: 10
  },
  paper: {
    borderRadius: '10px !important'
  },
  planTxt:{
    marginTop: '-30px !important',
    position: 'absolute',
    fontFamily: 'roboto-regular',
    marginLeft: '21px',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  greyBtn:{
    color: "#697683",
    fontFamily: 'roboto-regular',
  },
  linkText: {
    color: '#017aef',
    cursor: 'pointer',
    fontFamily: 'roboto-regular',
  },
  table: {
    minWidth: 650,
  },
  btn:{
    fontFamily: 'roboto-regular',
    textTransform:"initial"
  },
  cancelTxt: {
    color: 'red',
    fontSize:15,
    fontFamily: 'roboto-regular',
  },
  
});

const DialogTitle = withStyles(styles)((props: any) => {
  const { children, classes, onClose, ...other } = props;
  return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
    <div className={classes.header}>
      {children}
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <img src={'/assets/icons/creatordashboard/project-modal-close.svg'} alt={'img'}/>
        </IconButton>
      ) : null}
    </div>
  </MuiDialogTitle>
  );
});
const BillingComponent = (details:any) => {
  let billingdetail: any = [];
  let users: any = [];
  let roles: any = [];
  const pricing : any = {"clever":"199","smart":"299","genius":"499"};
  let isTrial = false;
  let trial_period = 0;
  let active_users_count = 0;
  let licensesCount = 1;
  let next_due_date = "";
  let max_participants = 0;
  
  const [popUpOpen, setPopUpOpen] = useState(false);
  const [cardAddPopup, setCardAddPopup] = useState(false);
  const [upgradePopup, setUpgradePopup] = useState(false);
  const [addLicencePopp, setAddLicencePopup] = useState(false);
  const [successModal, setsuccessModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState('');
  const [message, setMessage] = useState('');
  const [isAnyActiveSubsciption, setisAnyActiveSubsciption] = useState(false);

  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || '{}') : "";
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const { stripeCustomerDetail} = useSelector((state: any) => state.adminUser);
  const dispatch = useDispatch();
  const [isOpenChargePopup, setisOpenChargePopup] = useState(false);
  const [stripeMode, setStripemode] = useState('TEST');

  // Create our number formatter.
  const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      //minimumFractionDigits: 2,
  });

  const closeChargeModal = () => {
    setisOpenChargePopup(false)
  };
  const openChargeModal = () => {
    setisOpenChargePopup(true)
  };
  useEffect(() => {
      if (stripeCustomerDetail && stripeCustomerDetail.subscriptionsList && stripeCustomerDetail.subscriptionsList.length) {
        if(details && details.details && details.details['billingDetails'].data && details.details['billingDetails'].data.stripe_subscription_id){
          const filteredSub = stripeCustomerDetail.subscriptionsList.filter(function(obj: any) {
              if (obj.id === details.details['billingDetails'].data.stripe_subscription_id && obj.status ==="active") {
                  return obj
              }
          });
          if(filteredSub.length > 0){
            setisAnyActiveSubsciption(true)
          }
        }
      }
  }, [stripeCustomerDetail])

  useEffect(() => {
    dispatch(getStripeProductsList(apolloClient.client));
  }, [apolloClient.client, dispatch, loginUserData.user_id]);
  useEffect(() => {
    getStripeMode()
  }, []);
  
  if(details && details.details){
    billingdetail = details.details['billingDetails'].data;
    const  temp_trial_period = UtilService.calculateTrialDays(billingdetail.pay_started_at);
    trial_period = billingdetail.billing_period  - temp_trial_period;
    if(trial_period < 0){
      trial_period = 0;
    }
    
    if(billingdetail.pay_status == 'TRIAL'){
      isTrial = true;
    }

    max_participants = billingdetail.max_participants ? billingdetail.max_participants : 0;
    next_due_date = UtilService.calculateNextDate(billingdetail.pay_started_at, parseFloat(billingdetail.billing_period));   
    
    users = details.details['users'];
    roles = details.details['roles'];
    

    const admin_roleid = roles ? roles.filter((val:any) => val.role_name === "admin")[0] : {role_id: "0"};
    const creator_roleid = roles ? roles.filter((val:any) => val.role_name === "creator")[0] : {role_id: "0"};
    const subscriber_roleid = roles ? roles.filter((val:any) => (val.role_name === "subscriber" || val.role_name === "subscriberclever" || val.role_name === "subscribersmart" || val.role_name === "subscribergenius")) : [{role_id: "0"}];

    const isuseradmin = (loginUserData && loginUserData.role_access) ? loginUserData.role_access.filter((val:any) => val.access_name === "admin_users") : null;
    const isusertrialadmin = (loginUserData && loginUserData.role_access) ? loginUserData.role_access.filter((val:any) => val.access_name === "trial_admin") : null;
    const system_flagged = loginUserData ? loginUserData.system_flagged : false;

    
    if(system_flagged == true){
      active_users_count = users.length;
    }else {
      users.map((val: any) => {
        if(val.department_id == loginUserData.department_id && val.active===true){
          if(isuseradmin && isuseradmin[0].access_value){
            if(val.role_id == admin_roleid.role_id || val.role_id == creator_roleid.role_id){
              active_users_count++;
            }
          }else if(isusertrialadmin && isusertrialadmin[0].access_value && val.active===true){
            if(val.role_id == loginUserData.role_id  || subscriber_roleid.filter((v:any) => v.role_id == val.role_id)[0]){
              active_users_count++;
            }
          }
        }
      })
    }
    billingdetail.active_users_count = active_users_count
    licensesCount = billingdetail.member_qty?billingdetail.member_qty:active_users_count
    
  }
  
  const openBuyNowPopUP = (plan:any) => {
    setPopUpOpen(true);
    setSelectedPlan(plan)
  }

  const getStripeMode = async () => {
        
        await axios.post(Config.API_URL, {
            query: `query getStripeMode{
                      getStripeMode{
                        data status message data
                      }
                    }`
        }, {
            headers: {
                accesstoken: auth_token ? auth_token : "",
                schemaname: "public",
                idToken: idToken ? idToken : ""
            }
        }).then(async (result:any) => {
            if(result.data.data.getStripeMode.status === "true"){
              setStripemode(result.data.data.getStripeMode.data.stripe_mode)
            }
        }).catch(( ) => {
          
        });
    }

  const closeBuyNowPopup = () =>{
    setPopUpOpen(false);
    setSelectedPlan('')
  }
  const openUpgradePopup = (plan:any) => {
    if(stripeCustomerDetail && stripeCustomerDetail.paymentMethods && stripeCustomerDetail.paymentMethods.length ===0){
      dispatch(notificationFail({},"Please enter your credit card detail first to upgrade"));
      return
    }
    setUpgradePopup(true);
    setSelectedPlan(plan)
  }

  const closeUpgradePopup = () =>{
    setUpgradePopup(false);
    setSelectedPlan('')
  }

  const closeAddLicencePopup = () =>{
    setAddLicencePopup(false);
    setSelectedPlan('')
  }

  const openAddUserLicencePopup = (plan:any) => {
    setAddLicencePopup(true);
    setSelectedPlan(plan)
  }

  const speaktoOurTeam = (value:any) => {
    let url = "";
    if(value == 'getintouch'){
      url = `${Config.CONTACT_US_URL}`;      
    }else if(value == 'price'){
      url = `${Config.COMPANY_URL}/pricing`;
    }
    window.open(url, "__blank");
  }

  const classes = useStyles();
  
  const openCloseSuccessModal = (msg:any) => {
    setsuccessModal(!successModal);
    setMessage(msg)
  };

  const closeAddcardPopup = () =>{
    setCardAddPopup(false);
  }
  
  const openCardAddPopup = () => {
    setCardAddPopup(true);
  }
  
  return (

    <>
      {<BackDropAnalyzeLoading loading={details && details.loader?true:false} />}
      {popUpOpen &&
        <PurchaseSubscriptionModal
          stripe_mode={stripeMode}
          onClose={closeBuyNowPopup}
          open={popUpOpen}
          departmentData={billingdetail}
          selectedPlan = {selectedPlan}
          openCloseSuccessModal={openCloseSuccessModal}
        />
      }
      {cardAddPopup &&
        <AddCardDetailModal
          stripe_mode={stripeMode}
          onClose={closeAddcardPopup}
          open={cardAddPopup}
          departmentData={billingdetail}
          selectedPlan = {selectedPlan}
        />
      }
      {upgradePopup &&
        <UpgradeSubscriptionModal
          stripe_mode={stripeMode}
          onClose={closeUpgradePopup}
          open={upgradePopup}
          departmentData={billingdetail}
          selectedPlan = {selectedPlan}
          openCloseSuccessModal={openCloseSuccessModal}
        />
      }
      {addLicencePopp &&
        <AddUserLicences
          stripe_mode={stripeMode}
          onClose={closeAddLicencePopup}
          open={addLicencePopp}
          departmentData={billingdetail}
          selectedPlan = {selectedPlan}
          openCloseSuccessModal={openCloseSuccessModal}
        />
      }
      {successModal && 
        <SuccessModal
          successModal={successModal}
          openCloseSuccessModal={openCloseSuccessModal}
          message={message}
        />
      }
      <Card className={`billing-container ${classes.root}`} variant="outlined">
        <CardContent>
          <Grid container className="w-100">
            <Grid item lg={10} md={10} sm={10} xs={12} >
              <div className="billing-header">
                <p className="main-title">Immersion {(loginUserData.role_name.toLowerCase() == 'clever') ? "Clever" : (loginUserData.role_name.toLowerCase() == 'smart') ? "Smart" : (loginUserData.role_name.toLowerCase() == 'genius') ? "Genius" : "" }</p>
                {isTrial &&
                  <span className="trial-box">FREE TRIAL - {trial_period} Days LEFT</span>
                }
              </div>
            </Grid>
            <Grid item lg={2} md={2} sm={2} xs={12} style={{textAlign:'right'}}>
              <div>
                {(details && details.details && details.details['billingDetails'].data.stripe_product_sku)?
                  (isAnyActiveSubsciption && stripeCustomerDetail && stripeCustomerDetail.paymentMethods && stripeCustomerDetail.paymentMethods.length > 0)?
                    <Button variant="contained" className={classes.btn} style={{width: '172px'}} onClick={() => openAddUserLicencePopup(loginUserData.role_name)} color="primary">Add User Licenses</Button>
                    :
                    ""
                  :
                  <Button variant="contained" className={classes.btn} onClick={() => openBuyNowPopUP(loginUserData.role_name)} color="primary">Buy Now</Button>
                }
              </div>
            </Grid>
          </Grid>
          
          
          <Grid container className="w-100">
            <Grid item lg={4} md={4} sm={4} xs={12} >
              <div className="billing-header-col">
                <Typography variant="h2" component="h2">
                  ${(pricing[loginUserData.role_name.toLowerCase()])}
                </Typography>
                <Typography variant="body2" component="span">PER USER / MONTH <br /> BILLED ANNUALLY</Typography>
              </div>
              {(details && details.details && details.details['billingDetails'].data.stripe_product_sku && details.details['billingDetails'].data.member_qty) && 
                <div className="billing-header-col">
                  <Typography variant="h2" component="h2">{ details.details['billingDetails'].data.member_qty }</Typography>
                  <Typography variant="body2" component="span">LICENSES</Typography>
                </div>
              }
            </Grid>
            <Grid item lg={4} md={4} sm={4} xs={12} className="middle-column">
              <div className="billing-header-col">
                <Typography variant="h2" component="h2">{active_users_count}</Typography>
                <Typography variant="body2" component="span">ACTIVE USERS</Typography>
              </div>
              <div className="billing-header-col">
                <Typography variant="h2" component="h2">{ max_participants }</Typography>
                <Typography variant="body2" component="span">MAX PARTICIPANTS <br /> IN AN EXPERIENCE</Typography>
              </div>
            </Grid>
            <Grid item lg={4} md={4} sm={4} xs={12} >
              <div className="billing-header-col">
                <Typography variant="h2" component="h2">{formatter.format((parseFloat(pricing[loginUserData.role_name.toLowerCase()]) * 12) * licensesCount).replace(/\D00$/, '')}</Typography>
                <Typography variant="body2" component="span">NEXT INVOICE <br />DUE</Typography>
              </div>
              <Typography variant="h3" component="h3" className="date-text">{next_due_date}</Typography>
            </Grid>
          </Grid>
          <Grid container className="w-100" style={{marginTop:15}}>
            {(stripeCustomerDetail && stripeCustomerDetail.charges && stripeCustomerDetail.charges.length) ?
              <Grid item lg={3} md={3} sm={3} xs={12} >
                <div className={classes.linkText} onClick={()=>openChargeModal()}>&nbsp;View charge history</div>
              </Grid>
              :
              ""
            }
            {(details && details.details && details.details['billingDetails'].data.stripe_customer_id && stripeCustomerDetail && stripeCustomerDetail.paymentMethods) ?
              <Grid item lg={3} md={3} sm={3} xs={12} >
                <div className={classes.linkText} style={{width:"115px"}} onClick={()=>openCardAddPopup()}>&nbsp;Add card detail</div>
              </Grid>
              :
              ""
            }
          </Grid>
        </CardContent>
      </Card>

      <Card className={`billing-card-container ${classes.root}`} variant="outlined">
        <CardContent>
          <Grid container spacing={2}>
            {/*clever section*/}
            <Grid item lg={3} md={6} sm={6} xs={12} >
              <div className={`billing-card-box ${(loginUserData.role_name.toLowerCase() == 'clever') ? "select-billing" : "" }`}>
                <Typography variant="h3" component="h3">Clever</Typography>
                <Typography variant="body2" component="span" className="sm-text">CORE FUNCTIONALITY<br /> FOR BEGINNERS</Typography>
                <div className="billing-card-row">
                  <Typography variant="h2" component="h2">$199</Typography>
                  <Typography variant="body2" component="span" className="sm-text">PER USER<br /> PER MONTH <br />BILLED ANNUALLY</Typography>
                </div>
                <div className="billing-card-list limits-list">
                  <Typography variant="body2" component="span" className="title">Limits</Typography>
                  <List className="listing-con">
                    <ListItem><CheckIcon /><ListItemText primary="10 Participants / Experience" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Experiences Up To 1 Hour Length" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Unlimited Experiences" /></ListItem>
                  </List>
                </div>
                <div className="billing-card-list feature-list">
                  <Typography variant="body2" component="span" className="title">Features</Typography>
                  <List className="listing-con">
                    <ListItem><CheckIcon /><ListItemText primary="Measure Pre-Recorded Content" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Measure Live Experiences" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Participant Tagging" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Upload Experience Agenda" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="3rd Party Survey Integration" /></ListItem>
                  </List>
                </div>
                <div className="billing-card-list support-list">
                  <Typography variant="body2" component="span" className="title">Customer Success & Support</Typography>
                  <List className="listing-con">
                    <ListItem><CheckIcon /><ListItemText primary="48 Hour Email & Online Technical Support" /></ListItem>
                  </List>
                </div>
                <div className="btn-center">
                  {
                    (loginUserData.role_name.toLowerCase() == 'clever') ?
                      <Button variant="contained" className="btn-transparent">Your Current Plan</Button>
                    :
                      (details && details.details && details.details['billingDetails'].data.stripe_product_sku && loginUserData.role_name.toLowerCase() == 'clever' && !details.details['billingDetails'].data.subscription)?
                      <Button variant="contained" onClick={() => openBuyNowPopUP('clever')} className={classes.greyBtn}>Buy Now</Button>
                      :
                      (details && details.details && !details.details['billingDetails'].data.stripe_product_sku && loginUserData.role_name.toLowerCase() == "smart" && !details.details['billingDetails'].data.subscription)?
                      <Button variant="contained" onClick={() => openBuyNowPopUP('clever')} className={classes.greyBtn}>Buy Now</Button>
                      :
                      (trial_period && details && details.details && details.details['billingDetails'].data.stripe_product_sku && loginUserData.role_name.toLowerCase() == "smart" && !details.details['billingDetails'].data.subscription)?
                      <Button variant="contained" onClick={() => openBuyNowPopUP('clever')} className={classes.greyBtn}>Buy Now</Button>
                      :
                      (trial_period && details && details.details && details.details['billingDetails'].data.stripe_product_sku && !details.details['billingDetails'].data.subscription)?
                      <Button className={classes.greyBtn} variant="contained" onClick={() => openBuyNowPopUP('clever')}>Buy Now</Button>
                      :
                      (isTrial && trial_period && details && details.details && details.details['billingDetails'].data.stripe_product_sku && details.details['billingDetails'].data.subscription)?
                      <Button className={classes.greyBtn} variant="contained" onClick={() => openBuyNowPopUP('clever')}>Buy Now</Button>
                      :
                      ""
                  }
                </div>
              </div>
            </Grid>

            {/*smart section*/}
            <Grid item lg={3} md={6} sm={6} xs={12} >
              <div className={`billing-card-box ${(loginUserData.role_name.toLowerCase() == 'smart') ? "select-billing" : "" }`}>
                <Typography variant="h3" component="h3">Smart</Typography>
                <Typography variant="body2" component="span" className="sm-text">SECURITY & SCALE<br />FOR MOST BUSINESSES</Typography>
                <div className="billing-card-row">
                  <Typography variant="h2" component="h2">$299</Typography>
                  <Typography variant="body2" component="span" className="sm-text">PER USER<br /> PER MONTH <br />BILLED ANNUALLY</Typography>
                </div>
                <div className="billing-card-list limits-list">
                  <Typography variant="body2" component="span" className="title">Limits</Typography>
                  <List className="listing-con">
                    <ListItem><CheckIcon /><ListItemText primary="100 Participants/Experience" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Unlimited Experience Length" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Unlimited Experiences" /></ListItem>
                  </List>
                </div>
                <div className="billing-card-list feature-list">
                  <Typography variant="body2" component="span" className="title">Features</Typography>
                  <List className="listing-con">
                    <ListItem><CheckIcon /><ListItemText primary="Everything in Clever" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Secure Video Upload" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Live Experience View" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Calendar Integration for Scheduling" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Access to Immersion Audience Panel ($)" /></ListItem>
                  </List>
                </div>
                <div className="billing-card-list support-list">
                  <Typography variant="body2" component="span" className="title">Customer Success & Support</Typography>
                  <List className="listing-con">
                    <ListItem><CheckIcon /><ListItemText primary="24 Hour Email & Online Technical Support" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Limited Access Sage Support Neuroscience Team" /></ListItem>
                  </List>
                </div>
                <div className="btn-center">
                  {
                    (loginUserData.role_name.toLowerCase() == 'smart') ?
                      <>
                     {(details && details.details && details.details['billingDetails'].data.stripe_product_sku && loginUserData.role_name.toLowerCase() == 'smart')?
                      <span className={classes.planTxt} style={{position:"initial",marginLeft:"-6px"}}>Your Current Plan</span>
                      :
                      <>
                      <span className={classes.planTxt}>Your Current Plan</span>
                      <Button className={classes.btn} variant="contained" onClick={() => openBuyNowPopUP('smart')} color="primary">Buy Now</Button>
                      </>
                     }
                      </>
                    :
                    (loginUserData.role_name.toLowerCase() == 'clever') ?
                      (!trial_period && details && details.details && details.details['billingDetails'].data.stripe_product_sku)?
                      <Button className={classes.btn} variant="contained" onClick={() => openUpgradePopup('smart')} color="primary">Upgrade</Button>
                      :
                      (!isTrial && trial_period && details && details.details && details.details['billingDetails'].data.stripe_product_sku && (loginUserData.role_name.toLowerCase() == 'smart' || loginUserData.role_name.toLowerCase() == 'clever'))?
                      <Button variant="contained" color="primary" onClick={() => openUpgradePopup('smart')} className={classes.btn}>Upgrade</Button>
                      :
                      <Button className={classes.greyBtn} variant="contained" onClick={() => openBuyNowPopUP('smart')} >Buy Now</Button>
                      :
                      (trial_period && details && details.details && details.details['billingDetails'].data.stripe_product_sku && loginUserData.role_name.toLowerCase() != 'genius')?
                      <Button className={classes.btn} variant="contained" onClick={() => openBuyNowPopUP('smart')} color="primary">Buy Now</Button>
                      :
                      (!isTrial && trial_period && details && details.details && !details.details['billingDetails'].data.stripe_product_sku)?
                      <Button className={classes.greyBtn} variant="contained" onClick={() => openBuyNowPopUP('smart')}>Buy Now</Button>
                      :
                      (isTrial && trial_period && details && details.details && details.details['billingDetails'].data.stripe_product_sku)?
                      <Button className={classes.greyBtn} variant="contained" onClick={() => openBuyNowPopUP('smart')}>Buy Now</Button>
                      :
                      ""
                  }
                </div>
              </div>
            </Grid>

            {/*genius section*/}
            <Grid item lg={3} md={6} sm={6} xs={12} >
              <div className={`billing-card-box ${(loginUserData.role_name.toLowerCase() == 'genius') ? "select-billing" : "" }`}>
                <Typography variant="h3" component="h3">Genius</Typography>
                <Typography variant="body2" component="span" className="sm-text">SOPHISTICATED FEATURES <br />FOR NEXT-LEVEL TEAMS</Typography>
                <div className="billing-card-row">
                  <Typography variant="h2" component="h2">$499</Typography>
                  <Typography variant="body2" component="span" className="sm-text">PER USER<br /> PER MONTH <br />BILLED ANNUALLY</Typography>
                </div>
                <div className="billing-card-list limits-list">
                  <Typography variant="body2" component="span" className="title">Limits</Typography>
                  <List className="listing-con">
                    <ListItem><CheckIcon /><ListItemText primary="Unlimited Participants" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Unlimited Experience Length" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Unlimited Experiences" /></ListItem>
                  </List>
                </div>
                <div className="billing-card-list feature-list">
                  <Typography variant="body2" component="span" className="title">Features</Typography>
                  <List className="listing-con">
                    <ListItem><CheckIcon /><ListItemText primary="Everything in Smart" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="VIP & Reseller Options" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Secure Video Distribution" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Glance Tracking" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Reel Creation & Distribution" /></ListItem>
                  </List>
                </div>
                <div className="billing-card-list support-list">
                  <Typography variant="body2" component="span" className="title">Customer Success & Support</Typography>
                  <List className="listing-con">
                    <ListItem><CheckIcon /><ListItemText primary="12 Hour Email & Online Technical Support" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Phone/Video Technical Support" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Shared Sage Support Neuroscience Lead" /></ListItem>
                  </List>
                </div>
                <div className="btn-center">
                  {
                    (loginUserData.role_name.toLowerCase() == 'genius') ?
                      <Button variant="contained" className="btn-transparent">Your Current Plan</Button>
                    :
                      (!trial_period && details && details.details && details.details['billingDetails'].data.stripe_product_sku && (loginUserData.role_name.toLowerCase() == 'smart' || loginUserData.role_name.toLowerCase() == 'clever'))?
                      <Button variant="contained" color="primary" onClick={() => openUpgradePopup('genius')} className={classes.btn}>Upgrade</Button>
                      :
                      (!isTrial && trial_period && details && !details.details && !details.details['billingDetails'].data.stripe_product_sku && (loginUserData.role_name.toLowerCase() == 'smart' || loginUserData.role_name.toLowerCase() == 'clever'))?
                      <Button variant="contained" color="primary" onClick={() => openUpgradePopup('genius')} className={classes.btn}>Upgrade</Button>
                      :
                      (trial_period && details && !details.details && !details.details['billingDetails'].data.stripe_product_sku && (loginUserData.role_name.toLowerCase() == 'smart' || loginUserData.role_name.toLowerCase() == 'clever'))?
                      <Button variant="contained" onClick={() => openBuyNowPopUP('genius')} className={classes.greyBtn}>Buy Now</Button>
                      :
                      (!isTrial && trial_period && details && details.details && details.details['billingDetails'].data.stripe_product_sku && details.details['billingDetails'].data.subscription === true && (loginUserData.role_name.toLowerCase() == 'smart' || loginUserData.role_name.toLowerCase() == 'clever'))?
                      <Button variant="contained" color="primary" onClick={() => openUpgradePopup('genius')} className={classes.btn}>Upgrade</Button>
                      :
                      <Button variant="contained" onClick={() => openBuyNowPopUP('genius')} className={classes.greyBtn}>Buy Now</Button>
                      
                  }
                </div>
              </div>
            </Grid>

            {/*Enterprise section*/}
            <Grid item lg={3} md={6} sm={6} xs={12} >
              <div className="billing-card-box">
                <Typography variant="h3" component="h3">Enterprise</Typography>
                <Typography variant="body2" component="span" className="sm-text">THE WORKS <br />FOR THE MODERN ENTERPRISE</Typography>
                <div className="billing-card-row">
                  <div className="talking-icon">
                      <img src="/assets/icons/admin/noun_talking.svg" />
                  </div>
                  <Typography variant="h4" component="h4" className="connect-text">Connect with <br />our team</Typography>
                </div>
                <div className="billing-card-list limits-list">
                  <Typography variant="body2" component="span" className="title">Limits</Typography>
                  <List className="listing-con">
                    <ListItem><CheckIcon /><ListItemText primary="Unlimited Participants" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Unlimited Experience Length" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Unlimited Experiences" /></ListItem>
                  </List>
                </div>
                <div className="billing-card-list feature-list">
                  <Typography variant="body2" component="span" className="title">Features</Typography>
                  <List className="listing-con">
                    <ListItem><CheckIcon /><ListItemText primary="Everything in Genius" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Enterprise Security Features" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Enterprise Compliance Controls" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="API Access" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Single Sign-On (SSO)" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Multi-Team Dashboard" /></ListItem>
                  </List>
                </div>
                <div className="billing-card-list support-list">
                  <Typography variant="body2" component="span" className="title">Customer Success & Support</Typography>
                  <List className="listing-con">
                    <ListItem><CheckIcon /><ListItemText primary="Enterprise Level Support" /></ListItem>
                    <ListItem><CheckIcon /><ListItemText primary="Dedicated Sage Support Neuroscience Lead" /></ListItem>
                  </List>
                </div>
                <div className="btn-center">
                  <Button variant="contained" onClick={() => speaktoOurTeam('getintouch')} className={classes.greyBtn}>Speak to Our Team</Button>
                </div>
              </div>
            </Grid>
          </Grid>
          <div className="talk-text">Don’t See a Plan That Fits What You’re Looking For? <strong onClick={() => speaktoOurTeam('getintouch')} >Let’s Talk.</strong></div>
        </CardContent>
        <Dialog
          disableEscapeKeyDown
          fullWidth={true}
          maxWidth={'md'}
          scroll='paper'
          open={isOpenChargePopup}
          classes={{
            paper: classes.paper
          }}
        >
          <DialogTitle onClose={closeChargeModal}>Charges History</DialogTitle>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Amount</TableCell>
                  <TableCell align="center">Description</TableCell>
                  <TableCell align="center">Statement Descriptor</TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center">Receipt URL</TableCell>
                  <TableCell align="center">Created At</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {stripeCustomerDetail && stripeCustomerDetail.charges && stripeCustomerDetail.charges.length && 
                  stripeCustomerDetail.charges.map((val:any) => (
                  <TableRow key={val.id}>
                    <TableCell component="th" scope="row">
                      {"$" + (val.amount) / 100}
                    </TableCell>
                    <TableCell align="center">{val.description?val.description:"-"}</TableCell>
                    <TableCell align="center">{val.statement_descriptor?val.statement_descriptor:"-"}</TableCell>
                    <TableCell align="center">{val.status.charAt(0).toUpperCase() + val.status.slice(1)}</TableCell>
                    <TableCell align="center">
                      <Link  color="inherit" to={{pathname:val.receipt_url}}   target='_blank'>Receipt URL</Link>
                     </TableCell>
                    <TableCell align="center">{val.created ? moment.unix(val.created).format("MM/DD/YYYY hh:mm A") : ""}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Dialog>
      </Card>
    </>
  )
}
export default BillingComponent;

